import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SearchSortFields } from 'api';
import { useGroupSearch } from 'hooks';
import { GroupsWidget } from 'components';

const LatestGroups: FC = () => {
  const { t } = useTranslation();
  const { results, isEmpty, isInitialLoad } = useGroupSearch({
    results_from: 0,
    size: 8,
    sort: SearchSortFields.CreatedAt,
  });

  if (isInitialLoad || isEmpty) {
    return null;
  }

  return (
    <GroupsWidget elevation={1} maxResults={8} results={results} title={t('groups:latestGroups')} />
  );
};

export default LatestGroups;
